export enum EmailTone {
  COURTEOUS = 'COURTEOUS',
  PROFESSIONAL = 'PROFESSIONAL',
  SEVERE = 'SEVERE',
}

export enum DelayCategory {
  LATE_30_DAYS = 'LATE_30_DAYS',
  LATE_60_DAYS = 'LATE_60_DAYS',
  LATE_OVER_90_DAYS = 'LATE_OVER_90_DAYS',
}

export enum CreditStatus {
  NONE = 'NONE',
  NEARLY_REACHED = 'NEARLY_REACHED',
  REACHED = 'REACHED',
}

// Where a missing payment condition originates, so the banner drills into the right
// AcombaGO window: an invoice or a customer inscription (account entry).
export enum PaymentTermGapKind {
  INVOICE = 'INVOICE',
  INSCRIPTION = 'INSCRIPTION',
}

export enum SendEmailStatus {
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  FAILED = 'FAILED',
  AUTO_ATTACHMENT_FAILED = 'AUTO_ATTACHMENT_FAILED',
  TOTAL_ATTACHMENT_TOO_LARGE = 'TOTAL_ATTACHMENT_TOO_LARGE',
}

export enum EventType {
  EMAIL_SENT = 'EMAIL_SENT',
  NOTE_ADDED = 'NOTE_ADDED',
}
